import modulesDescripotionsObj from 'root/src/shared/descriptions/modules'
import propOr from 'ramda/src/propOr'
import path from 'ramda/src/path'

export default (state, moduleId) => (path(['tabs', moduleId, 'endpointId'], state)
	|| propOr(undefined, 'endpointId', modulesDescripotionsObj[moduleId]))

export const getEndpointId = (state, moduleId) => (path(['tabs', moduleId, 'endpointId', 0], state)
	|| path(['bannerTabs', 0, 'endpointId', 0], modulesDescripotionsObj[moduleId]))
